// src/hooks/useHomeVideo.js
import {useQuery} from 'react-query';
import {fetchHomeVideo} from "../api/homeVideoApi";

export const useHomeVideo = () => {
    return useQuery(['video'], () => fetchHomeVideo(), {
        refetchOnWindowFocus: false, // 根據需求調整
    });
};